import React from 'react';
import { ExplainPopover } from './ExplainPopover';
import { useFeatureFlag } from '../../hooks/use-feature-flag';

export interface ExplainIconProps {
  pluginId: string;
  entityType: string;
  entityId: string;
  field: string;
  ariaLabel?: string;
}

export const ExplainIcon: React.FC<ExplainIconProps> = ({ pluginId, entityType, entityId, field, ariaLabel = 'Explain' }) => {
  const enabled = useFeatureFlag('ai.core.explain.enabled');
  if (!enabled) return null;
  return (
    <ExplainPopover pluginId={pluginId} entityType={entityType} entityId={entityId} field={field}>
      <button
        type="button"
        aria-label={ariaLabel}
        style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1, display: 'inline-flex', alignItems: 'center' }}
      >
        <svg width="12" height="12" viewBox="0 0 20 20">
          <defs>
            <linearGradient id="explain-icon-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#2563eb" />
              <stop offset="100%" stopColor="#2563eb" />
            </linearGradient>
          </defs>
          <path fill="url(#explain-icon-grad)" d="M13,3 L14.5,9.5 L21,11 L14.5,12.5 L13,19 L11.5,12.5 L5,11 L11.5,9.5 Z" />
          <path fill="url(#explain-icon-grad)" d="M5,1 L5.9,3.6 L8.5,4.5 L5.9,5.4 L5,8 L4.1,5.4 L1.5,4.5 L4.1,3.6 Z" />
        </svg>
      </button>
    </ExplainPopover>
  );
};
